export default "__VITE_ASSET__GH6vg3RU__"